/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetBrandsDocument = gql`
    query GetBrands($companyId: Int!, $branchId: Int!) {
  companyBrands(companyId: $companyId, branchId: $branchId) {
    name
  }
}
    `;

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables> & ({ variables: GetBrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
      }
export function useGetBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export function useGetBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>;
export type GetBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsLazyQuery>;
export type GetBrandsSuspenseQueryHookResult = ReturnType<typeof useGetBrandsSuspenseQuery>;
export type GetBrandsQueryResult = Apollo.QueryResult<GetBrandsQuery, GetBrandsQueryVariables>;
export const GetProductCategoriesDocument = gql`
    query GetProductCategories($branchId: Int!, $itemsPerPage: Int, $delete: Boolean) {
  productCategories(
    branchId: $branchId
    itemsPerPage: $itemsPerPage
    delete: $delete
  ) {
    items {
      id
      name
      comment
      deleted
      parentCategory {
        id
        name
        deleted
      }
      company {
        id
        name
        address
        phone
        website
        deleted
        bookingQrLink
        isPremiumOn
        paidFeaturesPaginated {
          totalCount
        }
      }
      childCategories {
        id
        name
        deleted
        parentCategory {
          id
          name
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      delete: // value for 'delete'
 *   },
 * });
 */
export function useGetProductCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables> & ({ variables: GetProductCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
      }
export function useGetProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export function useGetProductCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export type GetProductCategoriesQueryHookResult = ReturnType<typeof useGetProductCategoriesQuery>;
export type GetProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesLazyQuery>;
export type GetProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetProductCategoriesSuspenseQuery>;
export type GetProductCategoriesQueryResult = Apollo.QueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const GetOneProductCategoryByIdDocument = gql`
    query GetOneProductCategoryById($id: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      productCategories(id: $id) {
        id
        name
        parentCategory {
          id
          name
          deleted
        }
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetOneProductCategoryByIdQuery__
 *
 * To run a query within a React component, call `useGetOneProductCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneProductCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneProductCategoryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetOneProductCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables> & ({ variables: GetOneProductCategoryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables>(GetOneProductCategoryByIdDocument, options);
      }
export function useGetOneProductCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables>(GetOneProductCategoryByIdDocument, options);
        }
export function useGetOneProductCategoryByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables>(GetOneProductCategoryByIdDocument, options);
        }
export type GetOneProductCategoryByIdQueryHookResult = ReturnType<typeof useGetOneProductCategoryByIdQuery>;
export type GetOneProductCategoryByIdLazyQueryHookResult = ReturnType<typeof useGetOneProductCategoryByIdLazyQuery>;
export type GetOneProductCategoryByIdSuspenseQueryHookResult = ReturnType<typeof useGetOneProductCategoryByIdSuspenseQuery>;
export type GetOneProductCategoryByIdQueryResult = Apollo.QueryResult<GetOneProductCategoryByIdQuery, GetOneProductCategoryByIdQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($page: Int, $itemsPerPage: Int, $nameSkuBarcode: String, $categoryId: Int, $brand: String, $stockStatus: String, $id: Int, $deleted: Boolean, $techMapId: Int, $branchId: Int!, $companyId: Int!, $needsFilterByBranch: Boolean) {
  products(
    page: $page
    itemsPerPage: $itemsPerPage
    nameSkuBarcode: $nameSkuBarcode
    categoryId: $categoryId
    brand: $brand
    stockStatus: $stockStatus
    id: $id
    deleted: $deleted
    branchId: $branchId
    companyId: $companyId
    needsFilterByBranch: $needsFilterByBranch
  ) {
    items {
      id
      name
      brand
      sku
      barcode
      unit {
        id
        name
      }
      alternativeUnit {
        id
        name
      }
      productStockStatus
      deleted
      productCategoryNew {
        id
        name
        deleted
        parentCategory {
          id
          name
          deleted
        }
      }
      technologicalMapProductRelations(techMapId: $techMapId) {
        id
        product {
          id
          name
          price
          cost
          deleted
        }
      }
      storageProductRelations(inStock: true) {
        id
        storage {
          id
          name
          branch {
            id
          }
        }
        quantityForRender
        quantity
        stockQuantity
        unit {
          id
          name
        }
      }
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      nameSkuBarcode: // value for 'nameSkuBarcode'
 *      categoryId: // value for 'categoryId'
 *      brand: // value for 'brand'
 *      stockStatus: // value for 'stockStatus'
 *      id: // value for 'id'
 *      deleted: // value for 'deleted'
 *      techMapId: // value for 'techMapId'
 *      branchId: // value for 'branchId'
 *      companyId: // value for 'companyId'
 *      needsFilterByBranch: // value for 'needsFilterByBranch'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables> & ({ variables: GetProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetOneProductDocument = gql`
    query GetOneProduct($id: Int, $branchId: Int!, $companyId: Int!, $needsFilterByBranch: Boolean) {
  products(
    id: $id
    branchId: $branchId
    companyId: $companyId
    needsFilterByBranch: $needsFilterByBranch
  ) {
    items {
      id
      name
      brand
      sku
      barcode
      image
      description
      criticalResidue
      price
      cost
      unitGroup {
        id
        name
      }
      unit {
        id
        name
      }
      alternativeUnit {
        id
        name
      }
      alternativeValue
      alternativeUnitGroup {
        id
        name
      }
      productStockStatus
      deleted
      productAttributes {
        id
        name
        value
      }
      productCategoryNew {
        id
        name
        deleted
        parentCategory {
          id
          name
          deleted
        }
      }
      technologicalMapProductRelations {
        id
        technologicalMap {
          id
          deleted
          name
        }
      }
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetOneProductQuery__
 *
 * To run a query within a React component, call `useGetOneProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      branchId: // value for 'branchId'
 *      companyId: // value for 'companyId'
 *      needsFilterByBranch: // value for 'needsFilterByBranch'
 *   },
 * });
 */
export function useGetOneProductQuery(baseOptions: Apollo.QueryHookOptions<GetOneProductQuery, GetOneProductQueryVariables> & ({ variables: GetOneProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneProductQuery, GetOneProductQueryVariables>(GetOneProductDocument, options);
      }
export function useGetOneProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneProductQuery, GetOneProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneProductQuery, GetOneProductQueryVariables>(GetOneProductDocument, options);
        }
export function useGetOneProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneProductQuery, GetOneProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneProductQuery, GetOneProductQueryVariables>(GetOneProductDocument, options);
        }
export type GetOneProductQueryHookResult = ReturnType<typeof useGetOneProductQuery>;
export type GetOneProductLazyQueryHookResult = ReturnType<typeof useGetOneProductLazyQuery>;
export type GetOneProductSuspenseQueryHookResult = ReturnType<typeof useGetOneProductSuspenseQuery>;
export type GetOneProductQueryResult = Apollo.QueryResult<GetOneProductQuery, GetOneProductQueryVariables>;
export const GeMainUnitsForCreateUpdateProductDocument = gql`
    query GeMainUnitsForCreateUpdateProduct {
  relations {
    mainUnits {
      id
      name
    }
  }
}
    `;

/**
 * __useGeMainUnitsForCreateUpdateProductQuery__
 *
 * To run a query within a React component, call `useGeMainUnitsForCreateUpdateProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeMainUnitsForCreateUpdateProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeMainUnitsForCreateUpdateProductQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeMainUnitsForCreateUpdateProductQuery(baseOptions?: Apollo.QueryHookOptions<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>(GeMainUnitsForCreateUpdateProductDocument, options);
      }
export function useGeMainUnitsForCreateUpdateProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>(GeMainUnitsForCreateUpdateProductDocument, options);
        }
export function useGeMainUnitsForCreateUpdateProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>(GeMainUnitsForCreateUpdateProductDocument, options);
        }
export type GeMainUnitsForCreateUpdateProductQueryHookResult = ReturnType<typeof useGeMainUnitsForCreateUpdateProductQuery>;
export type GeMainUnitsForCreateUpdateProductLazyQueryHookResult = ReturnType<typeof useGeMainUnitsForCreateUpdateProductLazyQuery>;
export type GeMainUnitsForCreateUpdateProductSuspenseQueryHookResult = ReturnType<typeof useGeMainUnitsForCreateUpdateProductSuspenseQuery>;
export type GeMainUnitsForCreateUpdateProductQueryResult = Apollo.QueryResult<GeMainUnitsForCreateUpdateProductQuery, GeMainUnitsForCreateUpdateProductQueryVariables>;
export const GetAlternativeUnitGroupsForCreateUpdateProductDocument = gql`
    query GetAlternativeUnitGroupsForCreateUpdateProduct($mainUnitId: Int!) {
  relations {
    alternativeUnitGroups(unitId: $mainUnitId) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAlternativeUnitGroupsForCreateUpdateProductQuery__
 *
 * To run a query within a React component, call `useGetAlternativeUnitGroupsForCreateUpdateProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlternativeUnitGroupsForCreateUpdateProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlternativeUnitGroupsForCreateUpdateProductQuery({
 *   variables: {
 *      mainUnitId: // value for 'mainUnitId'
 *   },
 * });
 */
export function useGetAlternativeUnitGroupsForCreateUpdateProductQuery(baseOptions: Apollo.QueryHookOptions<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables> & ({ variables: GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables>(GetAlternativeUnitGroupsForCreateUpdateProductDocument, options);
      }
export function useGetAlternativeUnitGroupsForCreateUpdateProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables>(GetAlternativeUnitGroupsForCreateUpdateProductDocument, options);
        }
export function useGetAlternativeUnitGroupsForCreateUpdateProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables>(GetAlternativeUnitGroupsForCreateUpdateProductDocument, options);
        }
export type GetAlternativeUnitGroupsForCreateUpdateProductQueryHookResult = ReturnType<typeof useGetAlternativeUnitGroupsForCreateUpdateProductQuery>;
export type GetAlternativeUnitGroupsForCreateUpdateProductLazyQueryHookResult = ReturnType<typeof useGetAlternativeUnitGroupsForCreateUpdateProductLazyQuery>;
export type GetAlternativeUnitGroupsForCreateUpdateProductSuspenseQueryHookResult = ReturnType<typeof useGetAlternativeUnitGroupsForCreateUpdateProductSuspenseQuery>;
export type GetAlternativeUnitGroupsForCreateUpdateProductQueryResult = Apollo.QueryResult<GetAlternativeUnitGroupsForCreateUpdateProductQuery, GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables>;
export const GetUnitsDocument = gql`
    query GetUnits {
  relations {
    units {
      id
      name
      unitGroup {
        id
        name
      }
      unitOrder
    }
  }
}
    `;

/**
 * __useGetUnitsQuery__
 *
 * To run a query within a React component, call `useGetUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
      }
export function useGetUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
        }
export function useGetUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
        }
export type GetUnitsQueryHookResult = ReturnType<typeof useGetUnitsQuery>;
export type GetUnitsLazyQueryHookResult = ReturnType<typeof useGetUnitsLazyQuery>;
export type GetUnitsSuspenseQueryHookResult = ReturnType<typeof useGetUnitsSuspenseQuery>;
export type GetUnitsQueryResult = Apollo.QueryResult<GetUnitsQuery, GetUnitsQueryVariables>;
export const GetProductsForTechMapDocument = gql`
    query GetProductsForTechMap($techMapId: Int, $page: Int, $itemsPerPage: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      technologicalMaps(techMapId: $techMapId) {
        totalCount
        technologicalMaps {
          id
          name
          deleted
          techMapProducts(page: $page, itemsPerPage: $itemsPerPage) {
            totalCount
            currentPage
            itemsPerPage
            pageCount
            techMapProducts {
              id
              product {
                id
                name
                brand
                sku
                price
                cost
                description
                barcode
                unit {
                  id
                  name
                  unitGroup {
                    id
                    name
                  }
                }
                units {
                  id
                  name
                }
                alternativeValue
                alternativeUnit {
                  id
                  name
                  unitGroup {
                    id
                    name
                    units {
                      id
                      name
                    }
                  }
                }
                deleted
                productCategoryNew {
                  id
                  name
                  deleted
                  parentCategory {
                    id
                    name
                    deleted
                  }
                }
              }
              requiredQuantity
              unit {
                id
                name
                unitGroup {
                  id
                  name
                  units {
                    id
                    name
                  }
                }
              }
            }
          }
          technologicalMapProductRelations {
            id
            product {
              id
              name
              price
              cost
              deleted
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductsForTechMapQuery__
 *
 * To run a query within a React component, call `useGetProductsForTechMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForTechMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForTechMapQuery({
 *   variables: {
 *      techMapId: // value for 'techMapId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetProductsForTechMapQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables> & ({ variables: GetProductsForTechMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables>(GetProductsForTechMapDocument, options);
      }
export function useGetProductsForTechMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables>(GetProductsForTechMapDocument, options);
        }
export function useGetProductsForTechMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables>(GetProductsForTechMapDocument, options);
        }
export type GetProductsForTechMapQueryHookResult = ReturnType<typeof useGetProductsForTechMapQuery>;
export type GetProductsForTechMapLazyQueryHookResult = ReturnType<typeof useGetProductsForTechMapLazyQuery>;
export type GetProductsForTechMapSuspenseQueryHookResult = ReturnType<typeof useGetProductsForTechMapSuspenseQuery>;
export type GetProductsForTechMapQueryResult = Apollo.QueryResult<GetProductsForTechMapQuery, GetProductsForTechMapQueryVariables>;
export const DeleteProductsDocument = gql`
    mutation DeleteProducts($productIds: [Int!]!, $branchId: Int!) {
  deleteProducts(productIds: $productIds, branchId: $branchId) {
    deleted
    failed
  }
}
    `;
export type DeleteProductsMutationFn = Apollo.MutationFunction<DeleteProductsMutation, DeleteProductsMutationVariables>;

/**
 * __useDeleteProductsMutation__
 *
 * To run a mutation, you first call `useDeleteProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductsMutation, { data, loading, error }] = useDeleteProductsMutation({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useDeleteProductsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductsMutation, DeleteProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductsMutation, DeleteProductsMutationVariables>(DeleteProductsDocument, options);
      }
export type DeleteProductsMutationHookResult = ReturnType<typeof useDeleteProductsMutation>;
export type DeleteProductsMutationResult = Apollo.MutationResult<DeleteProductsMutation>;
export type DeleteProductsMutationOptions = Apollo.BaseMutationOptions<DeleteProductsMutation, DeleteProductsMutationVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($companyId: Int!, $input: ProductInput!, $branchId: Int!) {
  createProduct(companyId: $companyId, input: $input, branchId: $branchId) {
    id
    name
    deleted
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($productId: Int!, $input: ProductInput!, $branchId: Int!) {
  updateProduct(productId: $productId, input: $input, branchId: $branchId) {
    id
    name
    brand
    sku
    barcode
    description
    criticalResidue
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const RestoreProductDocument = gql`
    mutation RestoreProduct($productId: Int!, $input: ProductInput!, $branchId: Int!) {
  restoreProduct(productId: $productId, input: $input, branchId: $branchId) {
    id
  }
}
    `;
export type RestoreProductMutationFn = Apollo.MutationFunction<RestoreProductMutation, RestoreProductMutationVariables>;

/**
 * __useRestoreProductMutation__
 *
 * To run a mutation, you first call `useRestoreProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProductMutation, { data, loading, error }] = useRestoreProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useRestoreProductMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProductMutation, RestoreProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProductMutation, RestoreProductMutationVariables>(RestoreProductDocument, options);
      }
export type RestoreProductMutationHookResult = ReturnType<typeof useRestoreProductMutation>;
export type RestoreProductMutationResult = Apollo.MutationResult<RestoreProductMutation>;
export type RestoreProductMutationOptions = Apollo.BaseMutationOptions<RestoreProductMutation, RestoreProductMutationVariables>;
export const CreateProductCategoryDocument = gql`
    mutation CreateProductCategory($companyId: Int!, $input: ProductCategoryNewInput!, $branchId: Int!) {
  createProductCategoryNew(
    companyId: $companyId
    input: $input
    branchId: $branchId
  ) {
    id
    name
    comment
    parentCategory {
      id
      name
      deleted
    }
    deleted
  }
}
    `;
export type CreateProductCategoryMutationFn = Apollo.MutationFunction<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>;

/**
 * __useCreateProductCategoryMutation__
 *
 * To run a mutation, you first call `useCreateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductCategoryMutation, { data, loading, error }] = useCreateProductCategoryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCreateProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>(CreateProductCategoryDocument, options);
      }
export type CreateProductCategoryMutationHookResult = ReturnType<typeof useCreateProductCategoryMutation>;
export type CreateProductCategoryMutationResult = Apollo.MutationResult<CreateProductCategoryMutation>;
export type CreateProductCategoryMutationOptions = Apollo.BaseMutationOptions<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>;
export const EditProductTechMapDocument = gql`
    mutation EditProductTechMap($relationId: Int!, $input: TechMapProductInput!, $branchId: Int!) {
  editProductTechMap(relationId: $relationId, input: $input, branchId: $branchId) {
    id
    product {
      id
      cost
      deleted
      name
      price
    }
  }
}
    `;
export type EditProductTechMapMutationFn = Apollo.MutationFunction<EditProductTechMapMutation, EditProductTechMapMutationVariables>;

/**
 * __useEditProductTechMapMutation__
 *
 * To run a mutation, you first call `useEditProductTechMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProductTechMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProductTechMapMutation, { data, loading, error }] = useEditProductTechMapMutation({
 *   variables: {
 *      relationId: // value for 'relationId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useEditProductTechMapMutation(baseOptions?: Apollo.MutationHookOptions<EditProductTechMapMutation, EditProductTechMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProductTechMapMutation, EditProductTechMapMutationVariables>(EditProductTechMapDocument, options);
      }
export type EditProductTechMapMutationHookResult = ReturnType<typeof useEditProductTechMapMutation>;
export type EditProductTechMapMutationResult = Apollo.MutationResult<EditProductTechMapMutation>;
export type EditProductTechMapMutationOptions = Apollo.BaseMutationOptions<EditProductTechMapMutation, EditProductTechMapMutationVariables>;
export const RemoveProductsFromTechMapDocument = gql`
    mutation RemoveProductsFromTechMap($relationIds: [Int!]!, $branchId: Int!) {
  removeProductsFromTechMap(relationIds: $relationIds, branchId: $branchId)
}
    `;
export type RemoveProductsFromTechMapMutationFn = Apollo.MutationFunction<RemoveProductsFromTechMapMutation, RemoveProductsFromTechMapMutationVariables>;

/**
 * __useRemoveProductsFromTechMapMutation__
 *
 * To run a mutation, you first call `useRemoveProductsFromTechMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductsFromTechMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductsFromTechMapMutation, { data, loading, error }] = useRemoveProductsFromTechMapMutation({
 *   variables: {
 *      relationIds: // value for 'relationIds'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useRemoveProductsFromTechMapMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductsFromTechMapMutation, RemoveProductsFromTechMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductsFromTechMapMutation, RemoveProductsFromTechMapMutationVariables>(RemoveProductsFromTechMapDocument, options);
      }
export type RemoveProductsFromTechMapMutationHookResult = ReturnType<typeof useRemoveProductsFromTechMapMutation>;
export type RemoveProductsFromTechMapMutationResult = Apollo.MutationResult<RemoveProductsFromTechMapMutation>;
export type RemoveProductsFromTechMapMutationOptions = Apollo.BaseMutationOptions<RemoveProductsFromTechMapMutation, RemoveProductsFromTechMapMutationVariables>;
export const AddProductTechMapDocument = gql`
    mutation AddProductTechMap($productId: Int!, $techMapId: Int!, $branchId: Int!) {
  addProductTechMap(
    productId: $productId
    techMapId: $techMapId
    branchId: $branchId
  ) {
    id
  }
}
    `;
export type AddProductTechMapMutationFn = Apollo.MutationFunction<AddProductTechMapMutation, AddProductTechMapMutationVariables>;

/**
 * __useAddProductTechMapMutation__
 *
 * To run a mutation, you first call `useAddProductTechMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductTechMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductTechMapMutation, { data, loading, error }] = useAddProductTechMapMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      techMapId: // value for 'techMapId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useAddProductTechMapMutation(baseOptions?: Apollo.MutationHookOptions<AddProductTechMapMutation, AddProductTechMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductTechMapMutation, AddProductTechMapMutationVariables>(AddProductTechMapDocument, options);
      }
export type AddProductTechMapMutationHookResult = ReturnType<typeof useAddProductTechMapMutation>;
export type AddProductTechMapMutationResult = Apollo.MutationResult<AddProductTechMapMutation>;
export type AddProductTechMapMutationOptions = Apollo.BaseMutationOptions<AddProductTechMapMutation, AddProductTechMapMutationVariables>;
export type GetBrandsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetBrandsQuery = { __typename?: 'Query', companyBrands: Array<{ __typename?: 'ProductParametersProxy', name: string } | null> };

export type GetProductCategoriesQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  delete?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories?: { __typename?: 'ProductCategoryNewPaginated', items?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', totalCount?: number | null } } | null, childCategories?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null> | null }> | null } | null };

export type GetOneProductCategoryByIdQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetOneProductCategoryByIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, productCategories?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null }> | null } | null } | null };

export type GetProductsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nameSkuBarcode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  brand?: Types.InputMaybe<Types.Scalars['String']['input']>;
  stockStatus?: Types.InputMaybe<Types.Scalars['String']['input']>;
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  techMapId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
  needsFilterByBranch?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, items?: Array<{ __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null, barcode?: string | null, productStockStatus?: string | null, deleted: boolean, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, alternativeUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null, technologicalMapProductRelations?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, product?: { __typename?: 'ProductProxy', id: number, name: string, price: string, cost?: string | null, deleted: boolean } | null }> | null, storageProductRelations?: Array<{ __typename?: 'StorageProductRelationProxy', id?: number | null, quantityForRender?: string | null, quantity?: any | null, stockQuantity?: string | null, storage?: { __typename?: 'StorageProxy', id: number, name: string, branch?: { __typename?: 'BranchProxy', id: number } | null } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null }> | null }> | null } | null };

export type GetOneProductQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
  needsFilterByBranch?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetOneProductQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, items?: Array<{ __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null, barcode?: string | null, image?: string | null, description?: string | null, criticalResidue?: number | null, price: string, cost?: string | null, alternativeValue?: number | null, productStockStatus?: string | null, deleted: boolean, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, alternativeUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, alternativeUnitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string } | null, productAttributes?: Array<{ __typename?: 'ProductAttributesProxy', id: number, name?: string | null, value?: string | null }> | null, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null, technologicalMapProductRelations?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, technologicalMap?: { __typename?: 'TechnologicalMapProxy', id: number, deleted: boolean, name: string } | null }> | null }> | null } | null };

export type GeMainUnitsForCreateUpdateProductQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GeMainUnitsForCreateUpdateProductQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', mainUnits?: Array<{ __typename?: 'UnitProxy', id: number, name: string } | null> | null } };

export type GetAlternativeUnitGroupsForCreateUpdateProductQueryVariables = Types.Exact<{
  mainUnitId: Types.Scalars['Int']['input'];
}>;


export type GetAlternativeUnitGroupsForCreateUpdateProductQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', alternativeUnitGroups?: Array<{ __typename?: 'UnitGroupProxy', id: number, name: string } | null> | null } };

export type GetUnitsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUnitsQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', units?: Array<{ __typename?: 'UnitProxy', id: number, name: string, unitOrder?: number | null, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string } | null }> | null } };

export type GetProductsForTechMapQueryVariables = Types.Exact<{
  techMapId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetProductsForTechMapQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, technologicalMaps?: { __typename?: 'TechnologicalMapPaginated', totalCount?: number | null, technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, deleted: boolean, techMapProducts?: { __typename?: 'TechMapProductPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, techMapProducts?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, requiredQuantity?: number | null, product?: { __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null, price: string, cost?: string | null, description?: string | null, barcode?: string | null, alternativeValue?: number | null, deleted: boolean, unit?: { __typename?: 'UnitProxy', id: number, name: string, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string } | null } | null, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null, alternativeUnit?: { __typename?: 'UnitProxy', id: number, name: string, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } | null } | null, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } | null } | null }> | null } | null, technologicalMapProductRelations?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, product?: { __typename?: 'ProductProxy', id: number, name: string, price: string, cost?: string | null, deleted: boolean } | null }> | null }> | null } | null } | null } | null };

export type DeleteProductsMutationVariables = Types.Exact<{
  productIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type DeleteProductsMutation = { __typename?: 'Mutation', deleteProducts: { __typename?: 'DeleteResponse', deleted: Array<number>, failed: Array<number> } };

export type CreateProductMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.ProductInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'ProductProxy', id: number, name: string, deleted: boolean } };

export type UpdateProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
  input: Types.ProductInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null, barcode?: string | null, description?: string | null, criticalResidue?: number | null } };

export type RestoreProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
  input: Types.ProductInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type RestoreProductMutation = { __typename?: 'Mutation', restoreProduct: { __typename?: 'ProductProxy', id: number } };

export type CreateProductCategoryMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.ProductCategoryNewInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type CreateProductCategoryMutation = { __typename?: 'Mutation', createProductCategoryNew: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } };

export type EditProductTechMapMutationVariables = Types.Exact<{
  relationId: Types.Scalars['Int']['input'];
  input: Types.TechMapProductInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type EditProductTechMapMutation = { __typename?: 'Mutation', editProductTechMap: { __typename?: 'TechnologicalMapProductRelationProxy', id: number, product?: { __typename?: 'ProductProxy', id: number, cost?: string | null, deleted: boolean, name: string, price: string } | null } };

export type RemoveProductsFromTechMapMutationVariables = Types.Exact<{
  relationIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type RemoveProductsFromTechMapMutation = { __typename?: 'Mutation', removeProductsFromTechMap: boolean };

export type AddProductTechMapMutationVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
  techMapId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type AddProductTechMapMutation = { __typename?: 'Mutation', addProductTechMap: { __typename?: 'TechnologicalMapProductRelationProxy', id: number } };
